import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SearchComponent} from './search/search-form/search.component';




const routes: Routes = [
  {path: '', redirectTo: 'search', pathMatch: 'full'},
  { path: 'search', component: SearchComponent },
  { path: 'search/type/:testTypeId/year/:testYear/id/:studentId/iin/:iin', component: SearchComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})

export class  AppRoutingModule {

}



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/app-routing.module.ts